import { useEffect } from 'react';
import { Box, Button, Skeleton, Typography } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { connect, useDispatch } from "react-redux";
import { getNotification } from '../../actions/notification';
import NotificationTabs from "./NotificationTabs";
import { useLocation, useNavigate } from 'react-router';
import { getItem } from '../../utils/DataProtection';

export default connect(
  ({ notification, notificationLoadError, i18n }) => ({ notification, notificationLoadError, i18n }),
  { getNotification }
)(props => {

  const location = useLocation();
  const navigate = useNavigate();
  const params = new URLSearchParams(location.search);
  const nodeid = params.get('nodeid');
  const dispatch = useDispatch();

  const nodeidLS = getItem('notification-nodeid');
  const activeNodeId = nodeid !== null ? nodeid : nodeidLS;
  const loadedNodeId = props?.notification?.notification?.nodeid;

  const loadNotification = () => {
    // A previous Meldung's error must not show for this one.
    dispatch({ type: 'CLEAR_NOTIFICATION_LOAD_ERROR' });
    props.getNotification({ nodeid: activeNodeId }, 'GETSINGLENOTIFICATION');
  };

  useEffect(() => {
    if (!activeNodeId) return;
    loadNotification();
  }, [activeNodeId, props.getNotification]);

  useEffect(() => {
    return () => {
      if(!window.location.href.includes("nodeid") && !window.location.pathname.includes("create-report") && !window.location.pathname.includes("edit-report") && !window.location.pathname.includes("notification-details") && !window.location.pathname.includes("edit-notification")){
      dispatch({ type: 'CLEARNOTIFICATION', payload: {} });
      }
    }
  }, [])

  const isLoading = !loadedNodeId || (activeNodeId && loadedNodeId !== activeNodeId);

  // The Meldung couldn't be loaded (404 "Meldung nicht gefunden.": deleted,
  // not readable, no owner — also an old link or bookmark; or any other
  // failure): say so instead of showing the loading boxes forever.
  const loadError = activeNodeId ? props.notificationLoadError : { status: 404 };
  if (loadError && isLoading) {
    const i18n = props.i18n || {};
    const notFound = loadError.status === 404;
    const goBack = () => (window.history.length > 1 ? navigate(-1) : navigate('/dashboard'));

    return (
      <div className="bxShadow" style={{ padding: "48px 24px", backgroundColor: "#fff" }}>
        <Box sx={{ alignItems: "center", display: "flex", flexDirection: "column", gap: 1.5, textAlign: "center" }}>
          <Typography variant="h2" data-testid="txt_notification_load_error">
            {notFound ? i18n.notification_not_found_title : i18n.notification_load_error_title}
          </Typography>
          <Typography sx={{ color: "rgba(0,0,0,0.6)", maxWidth: 480 }}>
            {notFound ? i18n.notification_not_found_text : i18n.notification_load_error_text}
          </Typography>
          <Box sx={{ display: "flex", gap: 2, mt: 2 }}>
            <Button variant="outlined" startIcon={<ArrowBackIcon />} onClick={goBack}>
              {i18n.notification_go_back}
            </Button>
            {!notFound ? (
              <Button variant="contained" onClick={loadNotification}>
                {i18n.notification_retry}
              </Button>
            ) : null}
          </Box>
        </Box>
      </div>
    );
  }

  return (
    <>
      {isLoading ? (
        <div className="bxShadow" style={{ padding: "24px", backgroundColor: "#fff" }}>
          <Skeleton variant="rectangular" height={140} style={{ marginTop: 12, borderRadius: 8 }} />
          <Skeleton variant="rectangular" height={320} style={{ marginTop: 30, borderRadius: 8 }} />
        </div>
      ) : (
        <NotificationTabs />
      )}
    </>
  );
})
